import { useEffect, useMemo, useState } from "react";
import Layout from "../../../Components/Layout";
import SettingFormsLayout from "../../../Components/ProForms/ProFormsLayout/SettingFormsLayout";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProSelectField from "../../../Components/Inputs/SelectField";
import ProTextInput from "../../../Components/Inputs/TextField";
import { changeMode, fieldTruePermission, prepareDefaultValues, prepareInitialConfig } from "../../../../utils/formHelper";
import { useForm } from "react-hook-form";
import ProCheckbox from "../../../Components/Inputs/CheckboxField";
import { FRINGE_BENEFIT_METHODS } from "../../../../utils/services/apiPath";
import { postApi } from "../../../../utils/services";
import { STAUTES } from "../../../../utils/constant";
import { errorToast, successToast } from "../../../../utils/toastHelper";
import { fringeBenefitOptions } from "../../../Constants/DropdownTypes";

const fringeBenefitAccountFormConfig = {
  fringeBenefitType: {
    label: "Fringe Benefit Type",
    perKey: "fringeBenefitType",
    rules: { required: "Fringe Benefit Type is required!" }
  },
  planName: {
    label: "Plan Name",
    perKey: "planName",
    rules: { required: "Plan Name is required!" }
  },
  isFunded: {
    label: "Is Funded",
    perKey: "isFunded"
  },
  accountNumber: {
    label: "Account Number",
    perKey: "accountNumber",
    rules: { required: "Account Number is required!" }
  },
  isActive: {
    label: "Is Active",
    perKey: "isActive"
  }
};

const FringeBeenefitAccountForm = () => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [formConfig, setFormConfig] = useState(prepareInitialConfig(fringeBenefitAccountFormConfig, "edit"));
  const backAction = () => navigate("/settings/fringe-benefit-accounts");
  const { handleSubmit, control, reset } = useForm({ defaultValues: prepareDefaultValues(fringeBenefitAccountFormConfig) });
  const defFormProps = { control };
  const isEditModeOn = useMemo(() => Object.values(formConfig).some(({ mode }) => mode === "edit"), [formConfig]);
  const onEdit = () => setFormConfig(changeMode("edit"));
  const [status, setStatus] = useState(STAUTES.IDLE);

  const onSubmit = async data => {
    if (isSaving) return;
    setIsSaving(true);

    const payload = {
      fringeBenefitType: data.fringeBenefitType,
      fringeBenefitPlanName: data.planName,
      isFunded: data.isFunded || false,
      accountNumber: data.accountNumber,
      isActive: data.isActive || false
    };

    setStatus(STAUTES.LOADING);
    const { error } = await postApi(FRINGE_BENEFIT_METHODS, payload);
    setIsSaving(false);
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    successToast(`Fringe Benefit Account added successfully.`);
    backAction();
  };

  const onCancel = () => {
    reset();
  };

  useEffect(() => {
    setFormConfig(changeMode("edit"));
  }, []);

  return (
    <Layout status={status} canView={true}>
      <SettingFormsLayout
        backAction={backAction}
        title={`Add Fringe Benefit Account`}
        backLabel="Go Back to All Fringe Benefit Account"
        beingEdited={isEditModeOn}
        onEdit={onEdit}
        onCancel={onCancel}
        onSave={handleSubmit(onSubmit)}
        isSaving={isSaving}
      >
        <Grid container spacing={2}>
          <ProSelectField {...defFormProps} {...formConfig.fringeBenefitType} permission={fieldTruePermission} options={fringeBenefitOptions} />
          <ProTextInput {...defFormProps} {...formConfig.planName} permission={fieldTruePermission} />
          <ProCheckbox {...defFormProps} {...formConfig.isFunded} permission={fieldTruePermission} />
          <ProTextInput {...defFormProps} {...formConfig.accountNumber} permission={fieldTruePermission} />
          <ProCheckbox {...defFormProps} {...formConfig.isActive} permission={fieldTruePermission} />
        </Grid>
      </SettingFormsLayout>
    </Layout>
  );
};

export default FringeBeenefitAccountForm;
